import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Sectors } from './pages/Sectors';
import { Method } from './pages/Method';
import { CaseStudies } from './pages/CaseStudies';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="31bianp7oiogh">
      <BrowserRouter data-id="element-1" data-mp="31cjk5p91r2w3">
        <Routes data-id="element-2" data-mp="2wjgrrkg09zhh">
          <Route element={<Layout data-id="element-4" data-mp="2wj8g1vvmd07v" />} data-id="element-3" data-mp="2wiyx2s8zrtbo">
            <Route index element={<Home data-id="element-6" data-mp="28ufnm9e7hai0" />} data-id="element-5" data-mp="2whx95n6vnccj" />
            <Route path="a-propos" element={<About data-id="element-8" data-mp="28sutulzptvl7" />} data-id="element-7" data-mp="28tmex2vosax8" />
            <Route path="services" element={<Services data-id="element-10" data-mp="23vuo6c6s2uum" />} data-id="element-9" data-mp="28sbend1g9lav" />
            <Route path="secteurs" element={<Sectors data-id="element-12" data-mp="23t8hsfvmildz" />} data-id="element-11" data-mp="23u9qidp62vsj" />
            <Route path="methode" element={<Method data-id="element-14" data-mp="3iiwdijzxza14" />} data-id="element-13" data-mp="3ijxsv0nzqion" />
            <Route path="references" element={<CaseStudies data-id="element-16" data-mp="3mlj9mx3nbh44" />} data-id="element-15" data-mp="3ijfunyhrpue3" />
            <Route path="blog" element={<Blog data-id="element-18" data-mp="3mjzsl4a6121a" />} data-id="element-17" data-mp="3mkrefndynled" />
            <Route path="blog/:slug" element={<BlogPost data-id="element-20" data-mp="3rbr9en3irte8" />} data-id="element-19" data-mp="3mjg93j4va5l5" />
            <Route path="contact" element={<Contact data-id="element-22" data-mp="3recerm310rgq" />} data-id="element-21" data-mp="3rdatypw7kqlt" />
            <Route path="*" element={<NotFound data-id="element-24" data-mp="67yvnd9206b" />} data-id="element-23" data-mp="5yh2n2cyzbp" />
          </Route>
        </Routes>
      </BrowserRouter>
    </MotionConfig>;
}